import { RestSlice } from 'src/redux/rest.slice';
import { Resource, localizationService } from 'src/services';
import { HaulerCleaningManifest } from '@rcp/types/src';

export const haulerCleaningHistorySlice = new RestSlice<HaulerCleaningManifest>(
	localizationService.getLocalizedString('haulerPortal.cleaningHistory.cleaningHistory'),
	Resource.HaulerCleaningHistory
);
export default haulerCleaningHistorySlice.rests.reducer;
